import React from 'react';

type ChildrenProps = {
  select: (index: number) => void;
  selectedIndex: number;
};

type Props = {
  initiallySelectedIndex?: number;
  children?: (props: ChildrenProps) => any;
  onSelectChange?: (selectedIndex: number) => void;
};

type State = {
  selectedIndex: number;
};

export class SelectableContent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedIndex: props.initiallySelectedIndex || 0,
    };

    this.select = this.select.bind(this);
  }

  select(index: number) {
    if (this.state.selectedIndex === index) {
      return;
    }
    this.setState({ selectedIndex: index });

    const { onSelectChange } = this.props;
    onSelectChange && onSelectChange(index);
  }

  render() {
    const { children } = this.props;

    if (!children) {
      return null;
    }

    return children({
      select: this.select,
      selectedIndex: this.state.selectedIndex,
    });
  }
}
